var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_In_Review",
    "data-name": "Icon - In Review",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z",
    fill: "#eb6e6e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rate_review_FILL0_wght400_GRAD0_opsz24",
    d: "M83.6-869.2h2.745l4.5-4.5a1.336,1.336,0,0,0,.3-.461,1.384,1.384,0,0,0,.1-.506,1.114,1.114,0,0,0-.113-.484,1.866,1.866,0,0,0-.292-.439l-.81-.855a1.367,1.367,0,0,0-.45-.3,1.355,1.355,0,0,0-.518-.1,1.385,1.385,0,0,0-.506.1,1.338,1.338,0,0,0-.461.3l-4.5,4.5Zm6.3-5.467-.833-.832Zm-4.95,4.117v-.855l2.273-2.273.45.4.4.45-2.272,2.273Zm2.723-2.723.4.45-.855-.855Zm.585,4.073H94.4V-871H90.058ZM80-862v-16.2a1.733,1.733,0,0,1,.529-1.271A1.733,1.733,0,0,1,81.8-880H96.2a1.733,1.733,0,0,1,1.271.529A1.733,1.733,0,0,1,98-878.2v10.8a1.733,1.733,0,0,1-.529,1.271,1.733,1.733,0,0,1-1.271.529H83.6Zm2.835-5.4H96.2v-10.8H81.8v11.812Zm-1.035,0v0Z",
    transform: "translate(-71 888)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.8a015555f53dd5cfb0a362a9fd736e4b.svg";
export { ForwardRef as ReactComponent };